export default __webpack_public_path__ + "static/media/icon-trash-error.5e884aee.svg";